<template>
  <title>
    <a href="/app#/news">
    <div class="logo"><img src="https://www.asspm.fr/lab/data/apps/asspm/images/logo.png" class="show"></div>
    <div class="title">
      <div class="name">SITE OFFICIEL <span class="color">A</span>VENIR <span class="color">S</span>PORT <span
              class="color">S</span>AINT <span class="color">P</span>IERRE <span class="color">M</span>ONTREVAULT
      </div>
      <div class="adress">
        Avenir Sport St Pierre Montrevault,&nbsp;Allée de l'Écusson,&nbsp;49110 Saint-Pierre-Montlimart&nbsp;/&nbsp;Tél
        :02 72 77 02 73
      </div>
    </div>
    <div class="season">
      <div class="color">SAISON</div>
      <div>2025-26</div>
      <div class="bar bg"></div>
    </div>
    </a>  
    <div class="menu color" v-on:click="onclick"><v-icon name="bars" scale="1"/></div>
  </title>
</template>

<script>
  export default {
    name: 'Title',
    data() {
      return {
        toggleMenu: 0
      }
    },
    methods: {
      onclick() {
        this.toggleMenu += 1
        console.log("toggleMenuChange", this.toggleMenu);
        this.$emit("toggleMenuChange", this.toggleMenu);
      }
    }
  }
</script>

<style scoped lang="stylus">
  title
    @media screen and (min-width: 1080px)
      margin-top 35px
    background-image url(https://www.asspm.fr/lab/data/apps/asspm/images/stade-bandeau.jpg)
    text-align center
    display flex
    a
      display flex
      color #ffffff !important
      flex 8
    .menu
      @media screen and (min-width: 720px)
        display none
      flex 1
      background-color #ffffff
      display grid
      align-items center
      justify-content center
      cursor pointer
    .title
      flex 5
      margin auto 0
      .name
        font-weight bold
        @media screen and (min-width: 720px)
          font-size xx-large
      .adress
        font-size x-small
        @media screen and (max-width: 720px)
          font-size xx-small
          font-weight bold
          display none
    .logo
      flex 1
      margin auto 0
      img
        width 65%
        margin-top 5px
        margin-bottom 5px
    .season
      flex 1
      white-space nowrap
      font-weight bold
      margin auto 5px
      @media screen and (min-width: 720px)
        font-size x-large
      .bar
        width 60%
        height 10px
        margin 0 auto
</style>
